import * as React from 'react'
import {Blocks} from '@builder.io/sdk-react'
import {cn} from '@/lib/utils'

export type BuilderBlock = any

export type TabBoxProps = {
    attributes?: Record<string, any>
    content?: BuilderBlock[]
    builderBlock?: {
        id?: string
    }
    'data-testid'?: string
}

export const TabButtonBox = ({
    attributes,
    content = [],
    builderBlock,
    'data-testid': dataTestId
}: TabBoxProps) => {
    const {className, ...restAttributes} = attributes || {}

    return (
        <div
            className={cn('flex flex-col px-4 py-3', className)}
            {...restAttributes}
            data-testid={dataTestId || 'contentTabs-TabButtonBox'}
        >
            <Blocks
                path="component.options.content"
                blocks={content}
                parent={builderBlock?.id}
                data-testid="contentTabs-TabButtonBox-Blocks"
            />
        </div>
    )
}
